import * as React from "react";

const SvgReceipttax = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="m9 14 6-6M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2Z" />
      <path d="M10 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM15 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
    </g>
  </svg>
);

export default SvgReceipttax;
